import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import Usuarios from './Usuarios';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Tooltip } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
 
  
  avatar: {
    backgroundColor: red[500],
  },
}));


     
    
  var depsuser=[''];
  
export default function RecipeReviewCard(props) {

  const [funcaouser, setafuncaouser] = React.useState('');
  const [lotacao, setalotacao] = React.useState('');

//********************objeto veiculo******************* */

const [itemuser, setitemuser] = React.useState([]);
var tipo1='';
React.useEffect(() => {
  var st=0;
  
setitemuser(props.props);
console.log('props item vei = ' , itemuser.map(modelo=>(modelo.modelo)));



itemuser.forEach(modelo=>(st=modelo.status))

console.log('valor do status',st)
if(st==1){
  setState({...state,checkmanobra:true})
 }

 var usertipo;
itemuser.forEach(modelo=>(usertipo=modelo.usertipo));
if(usertipo==1){
  setafuncaouser("Usuário Comum")
  var cod;
  itemuser.forEach(modelo=>(cod=modelo.codunidadedepartamento));

  var db = firebase.firestore();
     
      var query0 = db.collection("departamentos").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().depnome);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
}else{
  if(usertipo==2){
    setafuncaouser("Secretário de Unidade/Departamento")
    var cod;
  itemuser.forEach(modelo=>(cod=modelo.codunidadedepartamento));

  var db = firebase.firestore();
     
      var query0 = db.collection("departamentos").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().depnome);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
  }else{
    if(usertipo==3){
      setafuncaouser("Chefe de Unidade/Departamento")
      var cod;
  itemuser.forEach(modelo=>(cod=modelo.codunidadedepartamento));

  var db = firebase.firestore();
     
      var query0 = db.collection("departamentos").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().depnome);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
    }else{
      if(usertipo==4){
        setafuncaouser("Secretário de Núcleo Administrativo")
        var cod;
  itemuser.forEach(modelo=>(cod=modelo.codcentroadm));

  var db = firebase.firestore();
     
      var query0 = db.collection("centroadm").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().nomecentroadm);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
      }else{
        if(usertipo==5){
          setafuncaouser("Diretor de Núcleo Administrativo")
          var cod;
  itemuser.forEach(modelo=>(cod=modelo.codcentroadm));

  var db = firebase.firestore();
     
      var query0 = db.collection("centroadm").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().nomecentroadm);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
        }else{
          if(usertipo==6){
            setafuncaouser("Secretário de Unidade de Transporte")
            var cod;
  itemuser.forEach(modelo=>(cod=modelo.codunidadetransporte));

  var db = firebase.firestore();
     
      var query0 = db.collection("unidadetransporte").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().nomeunidadetransporte);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
          }else{
            if(usertipo==7){
              setafuncaouser("Chefe de Unidade de Transporte")
              var cod;
  itemuser.forEach(modelo=>(cod=modelo.codunidadetransporte));

  var db = firebase.firestore();
     
      var query0 = db.collection("unidadetransporte").doc(cod);
      
        query0.get().then((doc) => {       
        if (doc.exists) {
          setalotacao(doc.data().nomeunidadetransporte);
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });
            }else{
              if(usertipo==8){
                setafuncaouser("Secretário NIT/PROINFRA")
              }else{
                if(usertipo==9){
                  setafuncaouser("Chefe NIT/PROINFRA")
                }
              }
            }
          }
        }

      }
      
    }
    
  }
}

},[itemuser]);


React.useEffect(()=>{

 

},[0==0]);


     
  //**************************controle deletar */
  /*const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const handleconfirmadelete=()=>{
  var user = firebase.auth();
  user.
  user.delete().then(function() {
    // User deleted.
  }).catch(function(error) {
    // An error happened.
  });
}

  const handledeletar=()=>{
    handleClickOpen();
  };


   <Tooltip title="Deletar">
            <IconButton id="btsalvar" aria-label="Salvar" onClick={handledeletar}//disabled={edita} type="submit" //onClick={handlesalvar}
            >
               <DeleteForeverIcon />
             </IconButton>
             </Tooltip>

             <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Deletar Usuário"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Você está prestes a deletar de forma permamente este usuário:
            {itemuser.map(modelo=>(modelo.nome))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleconfirmadelete} color="primary" autoFocus>
            Deletar
          </Button>
        </DialogActions>
      </Dialog>
             


     //************************************controle interruptor*/
     
  
  const [state, setState] = React.useState({
    checkmanobra:false,});

  const handlemanobra = (event) => {
    
    
      setState({ ...state, [event.target.name]: event.target.checked });
    
    
    console.log('val state ', event.target.checked)
    var estado = event.target.checked;
    var userid;
    var usertipo;
    var cod3;
    itemuser.forEach(modelo=>(cod3=modelo.codunidadedepartamento));
    var cod5;
    itemuser.forEach(modelo=>(cod5=modelo.codcentroadm));
    var cod7;
    itemuser.forEach(modelo=>(cod7=modelo.codunidadetransporte));

    itemuser.forEach(modelo=>(userid=modelo.id));
    itemuser.forEach(modelo=>(usertipo=modelo.usertipo));
    var user = firebase.firestore().collection("usuarios").doc(userid);
    
    return user.update({userstatus:event.target.checked})
    .then(() => {
        console.log("Document successfully updated!");
        if(estado){
          if (usertipo==3) {
           // var cod;
            //itemuser.forEach(modelo=>(cod=modelo.codunidadedepartamento));
            console.log("Document cod dep!", cod3);
            var dep = firebase.firestore().collection("departamentos").doc(cod3);
    
              return dep.update({status:true})
              .then(() => {
                console.log("Document successfully updated!");
              })
              .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
              });
      
          } else {
            if (usertipo==5) {
            //  var cod;
           // itemuser.forEach(modelo=>(cod=modelo.codcentroadm));
            console.log("Document successfully capaz !" ,cod5);
            var cen = firebase.firestore().collection("centroadm").doc(cod5);
    
              return cen.update({status:true})
              .then(() => {
                console.log("Document successfully updated!");
              })
              .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
              });
            } else {
              if (usertipo==7) {
                //var cod;
           // itemuser.forEach(modelo=>(cod=modelo.codunidadetransporte));
            console.log("Document successfully capaz !" , cod7);
            var unit = firebase.firestore().collection("unidadetransporte").doc(cod7);
    
              return unit.update({status:true})
              .then(() => {
                console.log("Document successfully updated!");
              })
              .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
              });
              }
              
            }
            
          }
        }
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
  };
 
      //********************************************************************** */


  const classes = useStyles();
  
  
  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <AccountCircleIcon />
               </Avatar>
             }
            
             title= {itemuser.map(modelo=>(modelo.nome))}
             subheader= {itemuser.map(modelo=>(modelo.siape))}
             
     
           />
            <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
         {funcaouser}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
         {lotacao}
        </Typography>
            
            <Typography variant="body2" color="textSecondary" component="p">
          Telefone: {itemuser.map(modelo=>(modelo.telefone))}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          E-mail: {itemuser.map(modelo=>(modelo.email))}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {itemuser.map(modelo=>(modelo.campi))}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {itemuser.map(modelo=>(modelo.deps))}
        </Typography>
        

      </CardContent>
          
            <CardActions disableSpacing>
           
            <FormGroup row>
            <FormControlLabel
             control={
              <Tooltip title="Ativar/Desativar">
              <Switch
                 checked={state.checkmanobra}
                 onChange={handlemanobra}
                 name="checkmanobra"
                 color="primary"
               />
               </Tooltip>
             }
             label="Ativo"
           />
           
         </FormGroup>
     
                    
        
     
           </CardActions>
           
         </Card>
  );
}